export enum PayedPaymentLinkStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export interface PaymentWallet {
  walletPaymentLinkAttemptId: number;
  status: PayedPaymentLinkStatus;
  referenceId: string;
}

export enum PaymentLinkStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PAID = 'PAID',
}
export interface PaymentLink {
  externalReferenceId: string;
  amount: number;
  currency: string;
  description: string;
  name: string;
  status: PaymentLinkStatus;
}

export interface PaymentLinkOwner {
  name: string;
  country: string;
  profilePicture: string;
}

/**
 * @deprecated - remove
 */
export interface PaymentLinkSellerProfile {
  sellerName: string;
  websiteLink: string;
  profilePicture: string;
}
export interface PaymentLinkBuyerDetails {
  canPay: boolean;
  reason?: {
    title: string;
    subtitle?: string;
  };
}
